import { supportedLanguages, defaultLanguage } from '@/i18n'
import { translatePath } from '@/i18n/routes'

export const SITE_URL = 'https://zambelaureato.it'

export type SeoLinks = {
  canonical: string
  /** Una voce per lingua più `x-default` (la lingua predefinita), per i tag `hreflang`. */
  alternates: { hreflang: string; href: string }[]
}

/** URL assoluti di canonical e alternative di lingua per un percorso del sito (`/it/zambepong/…`). */
export function seoLinks(pathname: string): SeoLinks {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  return {
    canonical: SITE_URL + path,
    alternates: [
      ...supportedLanguages.map((lang) => ({ hreflang: lang, href: SITE_URL + translatePath(path, lang) })),
      { hreflang: 'x-default', href: SITE_URL + translatePath(path, defaultLanguage) },
    ],
  }
}

/** Pagine del gioco (ZambePong, ZambeBet) contro il resto, per scegliere titolo e descrizione. */
export const isGamePath = (pathname: string): boolean => /^\/[a-z]{2}\/zambepong(\/|$)/.test(pathname)
